<template>

    <div>
        <div class="modal fade" style="display: block; opacity: 1;" tabindex="-1" id="modalDeleteCompetitor">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <a @click="closeModal" href="javascript:void(0)" class="close" data-dismiss="modal" aria-label="Close">
                    <em class="icon ni ni-cross"></em>
                </a>
                <div class="modal-header">
                    <h5 class="modal-title">Delete competitor <span v-text="competitor.firstname"></span> <span v-text="competitor.lastname"></span></h5>
                </div>
                <div class="modal-body">

                    <div id="form-edit-competitor">

                        <input type="hidden" name="competitor_id" id="competitor_id" v-model="competitor.id" />

                        <p>This action cannot be undone.</p>

                    </div>

                </div>
                <div class="modal-footer bg-light">
                    <button type="button" @click="closeModal" class="btn btn-light">Cancel</button>
                    <button type="button" @click="deleteCompetitor" class="btn btn-danger">Delete</button>
                </div>
            </div>
        </div>
    </div>
        <div class="modal-backdrop fade show"></div>
    </div>

</template>

<script>
    export default {
        name: 'deleteCompetitorModal',
        props: [
            'competitor',
        ],

        data() {
            return {
                competitorInfo: {},
            }
        },

        mounted() {
            this.competitor = this.competitor;
        },

        methods: {
            deleteCompetitor() {
                this.$emit('onDelete', this.competitor);
            },
            closeModal() {
                this.$emit('closeModal');
            }
        }
    }
</script>
